import React from 'react';
import PropTypes from 'prop-types';

import PurchaseSuccessWithReferral from './PurchaseSuccessWithReferral';
import withModal from '../modal/withModal';

export const PURCHASE_SUCCESS_WITH_REFERRAL_MODAL =
  'modal/PURCHASE_SUCCESS_WITH_REFERRAL';

const propTypes = {
  actionProps: PropTypes.shape({
    onDismiss: PropTypes.func,
  }),
  onRequestClose: PropTypes.func,
};

const PurchaseSuccessWithReferralContainer = ({
  actionProps: { onDismiss, ...actionProps } = {},
  onRequestClose,
  ...props
}) => {
  return (
    <PurchaseSuccessWithReferral
      {...actionProps}
      {...props}
      onDismiss={
        onDismiss
          ? () => {
              onDismiss();
              onRequestClose();
            }
          : undefined
      }
    />
  );
};

PurchaseSuccessWithReferralContainer.propTypes = propTypes;

export default withModal(PurchaseSuccessWithReferralContainer, {
  name: PURCHASE_SUCCESS_WITH_REFERRAL_MODAL,
  dismissible: false,
  size: 'sm',
  className: 'purchase-success-referral-modal',
  overlayClassName: 'purchase-success-referral-modal-overlay',
  type: 'full',
});
